module.exports = {"__schema":{"types":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragmentTypes.json
// module id = 623
// module chunks = 0